<template>
<m-pageframe
    :title="title"
>
<v-container
    fluid
    style="padding: 15px"
>
    <m-rc-crm-organization-meta-data
        v-on:update-organization="onUpdateOrganizationMetaData"
    />

    <h2>Notes</h2>

    <m-rc-crm-notes
        :organization_id="$route.params.organization_id"
    />

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');
const Time = require('@/js/time.js');
export default {
    data() {
        return {
            organization: null,
        }
    },

    mounted () {
        this.doUpdate();
    },

    methods: {
        onUpdateOrganizationMetaData(meta_data)
        {
            this.organization = meta_data;
        },
    },

    computed: {
        title() {
            if ( this.organization == null )
                return 'View Organization';

            return this.organization.label;
        }
    },
}
</script>

<style lang="scss" scoped>
</style>